import styled, { css } from 'styled-components';
import { colorUtils } from '@prisjakt/ui-base';

interface SearchSelectableProps {
  selected: boolean;
}
export const SearchSelectable = styled.div<SearchSelectableProps>`
  ${p =>
    p.selected &&
    css`
      background: ${colorUtils.setRgbaAlpha(p.theme.colors.maybeBlue700, 0.2)};
      border-radius: 5px;

      > a {
        background: none;
      }
    `}

  &:hover {
    background-color: ${p => p.theme.colors.base100};
  }
`;
